import { FC } from "react";
import { Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { Status } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { IStatusChipProps } from "./StatusChip.models";

export const StatusChip: FC<IStatusChipProps> = ({ variant }) => {
  const variants = {
    [Status.ACCEPTED]: {
      labelUT: "Zaakceptowany",
      bgcolor: "green.50",
      color: "green.900",
      borderColor: "green.500",
      icon: null,
    },
    [Status.WAITING_FOR_APPROVAL]: {
      labelUT: "Oczekuje na akceptację",
      bgcolor: "grey.100",
      color: "common.black",
      borderColor: "grey.300",
      icon: null,
    },
    [Status.CORRECTION_REQUIRED]: {
      labelUT: "Wymagana zmiana",
      bgcolor: "grey.100",
      color: "deepOrange.900",
      borderColor: "deepOrange.100",
      // icon: <EditNote sx={{ fontSize: "11px" }} />,
    },
    [Status.CANCELLED]: {
      labelUT: "Anulowany",
      bgcolor: "red.50",
      color: "red.800",
      borderColor: "red.200",
      icon: null,
    },
    [Status.REJECTED]: {
      labelUT: "Odrzucony",
      bgcolor: "red.50",
      color: "red.800",
      borderColor: "red.200",
      icon: null,
    },
  };
  const currentVariant = variants[variant];

  return (
    <Typography
      sx={{
        display: "inline-flex",
        alignItems: "center",
        width: "max-content",
        backgroundColor: currentVariant.bgcolor,
        fontSize: "0.625rem",
        fontWeight: 800,
        color: currentVariant.color,
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        padding: "0.25rem 0.5rem",
        border: "1px solid",
        borderColor: currentVariant.borderColor,
        borderRadius: "0.25rem",
        "& > svg": {
          marginRight: "0.25rem",
        },
      }}
      component="span"
      data-testid="absence-request-status"
    >
      {/* {currentVariant.icon} */}
      {__(currentVariant.labelUT)}
    </Typography>
  );
};
